<p-dialog
  [visible]="showPopup()"
  (onHide)="closeCreateTaskPopup()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '1025px': '100vw', '640px': '100vw' }"
  [style]="{ width: '55vw' }"
  styleClass="no-header-modal"
  aria-label="task-create-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form
      [formGroup]="formGroup"
      (ngSubmit)="CreateTask()"
      aria-label="task-create-form"
    >
      <p-toast (onClose)="closeCreateTaskPopup()" aria-label="toast-message" />

      <!-- Header -->
      <div
        class="p-3 sticky top-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
        aria-label="task-create-header"
      >
        @if (
          (clientIds$ | async)?.length > 0 &&
          (clientIds$ | async)?.length < 2 &&
          taskCreateType() !== getTaskCreateType.Bulk
        ) {
          <h2 class="mb-0 text-sm" aria-label="create-single-task-title">
            {{ 'Shared.TASK.TASK-CREATE.CREATE_TASK' | translate }}
          </h2>
        }
        @if (
          (clientIds$ | async)?.length > 0 &&
          (clientIds$ | async)?.length > 1 &&
          taskCreateType() !== getTaskCreateType.Bulk
        ) {
          <h2 class="mb-0 text-sm" aria-label="create-multiple-tasks-title">
            {{ 'Shared.TASK.TASK-CREATE.CREATE_TASK_FOR' | translate }}
            <strong
              >{{ (clientIds$ | async)?.length }}
              {{ 'Shared.TASK.TASK-CREATE.MEMBERS' | translate }}
            </strong>
          </h2>
        }
        @if (taskCreateType() === getTaskCreateType.Bulk) {
          <h2 class="mb-0 text-sm" aria-label="create-bulk-task-title">
            {{ 'SEND_TASK_BULK.SEND_BULK_TASK' | translate }}
          </h2>
        }
        @if (taskCreateType() === getTaskCreateType.Campaign) {
          <h2 class="mb-0 text-sm" aria-label="create-campaign-task-title">
            {{ 'SEND_TASK_BULK.SEND_BULK_TASK' | translate }}
          </h2>
        }
        @if (taskCreateType() === getTaskCreateType.Automation) {
          <h2 class="mb-0 text-sm" aria-label="create-automation-task-title">
            {{ 'Shared.TASK.TASK-CREATE.CREATE_TASK' | translate }}
          </h2>
        }
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="ClosePopUp()"
          data-testid="close-dialog-button"
        ></div>
      </div>
      <!-- Header -->

      <!-- Content -->
      @if (
        taskCreateType() === getTaskCreateType.Automation &&
        showScheduleType.value
      ) {
        <automation-schedule-type
          [formGroup]="formGroup"
          [automationMaster]="automationMaster()"
          aria-label="automation-schedule-type"
        />
      }
      <!-- Content -->

      <!-- Content -->
      <div class="p-3 surface-100" aria-label="task-create-content">
        @if (
          showCampaign.value && taskCreateType() === getTaskCreateType.Bulk
        ) {
          <div
            class="flex align-items-center mb-2"
            aria-label="campaign-visibility-section"
          >
            <strong
              class="text-sm mb-0 mr-2 -mt-1 cursor-pointer"
              aria-label="campaign-visibility-label"
              >{{ 'SEND_TASK_BULK.IS_CAMPAIGNS' | translate }}</strong
            >
            <p-toggleSwitch
              formControlName="is_visible"
              aria-label="campaign-visibility-switch"
            />
          </div>
        }

        <!-- Form Group -->
        @if (
          IsVisibleFormControl.value &&
          taskCreateType() === getTaskCreateType.Bulk
        ) {
          <div class="mb-3" aria-label="campaign-name-section">
            <label
              for="campaign_name"
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="campaign-name-label"
              >{{ 'SEND_EMAIL.IS_CAMPAIGNS' | translate }}</label
            >
            <input
              type="text"
              id="campaign_name"
              formControlName="campaign_name"
              class="text-sm w-full"
              pInputText
              [placeholder]="'SEND_EMAIL.NAME_PLACEHOLDER' | translate"
              aria-label="campaign-name-input"
            />
            @if (
              CampaignNameFormControl.touched && CampaignNameFormControl.invalid
            ) {
              <app-error-msg
                [errors]="CampaignNameFormControl.errors"
                [fieldLabel]="'SEND_EMAIL.CAMPAIGN_NAME' | translate"
                aria-label="campaign-name-error"
              />
            }
          </div>
        }
        <!-- Form Group -->

        <!-- Form Group -->
        @if (
          IsVisibleFormControl.value &&
          taskCreateType() === getTaskCreateType.Bulk
        ) {
          <div class="mb-3" aria-label="campaign-description-section">
            <label
              for="campaign_description"
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="campaign-description-label"
              >{{ 'SEND_EMAIL.CAMPAIGN_DESCRIPTION' | translate }}</label
            >
            <textarea
              id="campaign_description"
              pInputTextarea
              formControlName="campaign_description"
              class="text-sm w-full h-4rem"
              [placeholder]="'SEND_EMAIL.DESC_PLACEHOLDER' | translate"
              aria-label="campaign-description-input"
            ></textarea>
            @if (
              CampaignDescriptionFormControl.touched &&
              CampaignDescriptionFormControl.invalid
            ) {
              <app-error-msg
                [errors]="CampaignDescriptionFormControl.errors"
                [fieldLabel]="'SEND_EMAIL.CAMPAIGN_DESCRIPTION' | translate"
                aria-label="campaign-description-error"
              />
            }
          </div>
        }
        <!-- Form Group -->

        <!-- Form Group -->
        @if (
          IsVisibleFormControl.value &&
          taskCreateType() === getTaskCreateType.Bulk
        ) {
          <div class="mb-3" aria-label="campaign-date-section">
            <label
              for="campaign_action_date"
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="campaign-date-label"
              >{{ 'SEND_EMAIL.SCHEDULE_DATE' | translate }}</label
            >
            <p-datepicker
              [showIcon]="true"
              id="campaign_action_date"
              formControlName="campaign_action_date"
              icon="fa fa-calendar font-light"
              dateFormat="M dd,yy"
              yearRange="2023:2030"
              [placeholder]="'SEND_EMAIL.CHOOSE_DATE' | translate"
              inputStyleClass="text-sm"
              aria-label="campaign-date-picker"
            />
            @if (
              CampaignActionDateFormControl.touched &&
              CampaignActionDateFormControl.invalid
            ) {
              <app-error-msg
                [errors]="CampaignActionDateFormControl.errors"
                [fieldLabel]="'SEND_EMAIL.SCHEDULE_DATE' | translate"
                aria-label="campaign-date-error"
              />
            }
          </div>
        }
        <!-- Form Group -->

        @if (
          showCampaign.value && taskCreateType() === getTaskCreateType.Bulk
        ) {
          <label
            for="content"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="content-label"
            >{{ 'SEND_SMS.CONTENT' | translate }}</label
          >
        }
        <div
          id="content"
          class="surface-0 shadow-3 border-round text-sm"
          aria-label="task-content-container"
        >
          <!-- Header -->
          @if (
            taskCreateType() !== getTaskCreateType.Campaign &&
            taskCreateType() !== getTaskCreateType.Automation
          ) {
            <div
              class="px-3 py-2 flex align-items-center border-bottom-1 border-300"
              aria-label="client-search-section"
            >
              @if (showPopup()) {
                <mini-search
                  class="w-full"
                  [id]="clientIds$ | async"
                  [initialData]="initialClients()"
                  [skipInitialLoad]="(initialClients()?.length ?? 0) > 0"
                  (clients)="setClient($event)"
                  [readonly]="(clientIds$ | async)?.length > 0"
                  [showCreateClient]="false"
                  (createProspect)="createProspect($event)"
                  [totalRecords]="totalRecords()"
                  [selectedAllData]="selectedAllData()"
                  (openclientsidebar)="openclientsidebar($event)"
                  aria-label="client-search"
                />
              }
            </div>
          }
          <!-- Header -->

          <!-- Content -->
          <div
            class="surface-50 text-sm py-3 px-4 border-top-1 border-bottom-1 border-300"
            aria-label="task-details-section"
          >
            <div class="grid" aria-label="task-details-grid">
              <div class="col-6 md:col-3" aria-label="task-category-section">
                <label
                  for="selectedTaskCategory"
                  class="text-700 text-xs mb-2 block uppercase"
                  aria-label="task-category-label"
                >
                  {{ 'Shared.TASK.TASK-CREATE.TASK_CATEGORY' | translate }}
                </label>
                <task-category
                  id="selectedTaskCategory"
                  [formGroup]="formGroup"
                  [controlName]="SelectedTaskCategory"
                  [categoryId]="taskCategoryId"
                  placeHolder="{{
                    'Shared.TASK.TASK-CREATE.SELECT' | translate
                  }}"
                  aria-label="task-category-selector"
                />
                @if (
                  SelectedTaskCategory.dirty && SelectedTaskCategory.invalid
                ) {
                  <app-error-msg
                    [errors]="SelectedTaskCategory.errors"
                    [fieldLabel]="
                      'Shared.TASK.TASK-CREATE.SELECT_TASK_CATEGORY' | translate
                    "
                    aria-label="task-category-error"
                  />
                }
              </div>
              <div class="col-6 md:col-3" aria-label="task-type-section">
                <label
                  for="selectedTask"
                  class="text-700 text-xs mb-2 block uppercase"
                  aria-label="task-type-label"
                >
                  {{ 'Shared.TASK.TASK-CREATE.TASK_TYPE' | translate }}
                </label>
                <p-select
                  [options]="taskTypeOptions"
                  optionLabel="name"
                  [placeholder]="'Shared.TASK.TASK-CREATE.SELECT' | translate"
                  styleClass="-ml-2 border-none surface-50 w-full text-sm text-900"
                  formControlName="selectedTask"
                  aria-label="task-type-dropdown"
                >
                  <ng-template pTemplate="selectedItem" let-selectedOption>
                    @if (selectedOption) {
                      <div
                        class="task-item task-item-value flex align-items-center text-sm"
                        aria-label="selected-task-type"
                      >
                        <i
                          [ngClass]="'mr-3 ' + selectedOption.icon"
                          aria-label="task-type-icon"
                        ></i>
                        <div class="text-sm" aria-label="task-type-name">
                          {{ selectedOption.name }}
                        </div>
                      </div>
                    }
                  </ng-template>
                  <ng-template let-tasktype pTemplate="item">
                    <div
                      class="task-item flex align-items-center"
                      aria-label="task-type-option"
                    >
                      <i
                        [ngClass]="'mr-3 ' + tasktype.icon"
                        aria-label="task-type-option-icon"
                      ></i>
                      <div class="text-sm" aria-label="task-type-option-name">
                        {{ tasktype.name }}
                      </div>
                    </div>
                  </ng-template>
                </p-select>
                @if (SelectedTask.dirty && SelectedTask.invalid) {
                  <app-error-msg
                    [errors]="SelectedTask.errors"
                    [fieldLabel]="
                      'Shared.TASK.TASK-CREATE.SELECT_TASK' | translate
                    "
                    aria-label="task-type-error"
                  />
                }
              </div>
              <div class="col-6 md:col-3" aria-label="priority-section">
                <label
                  for="selectedPriority"
                  class="text-700 text-xs mb-2 block uppercase"
                  aria-label="priority-label"
                >
                  {{ 'Shared.TASK.TASK-CREATE.PRIORITY' | translate }}
                </label>
                <priority
                  id="selectedPriority"
                  [formGroup]="formGroup"
                  [controlName]="SelectedPriority"
                  [priority]="priority"
                  placeHolder="{{
                    'Shared.TASK.TASK-CREATE.SELECT' | translate
                  }}"
                  [langCode]="languageCode"
                  aria-label="priority-selector"
                />
                @if (SelectedPriority.dirty && SelectedPriority.invalid) {
                  <app-error-msg
                    [errors]="SelectedPriority.errors"
                    [fieldLabel]="
                      'Shared.TASK.TASK-CREATE.SELECT_PRIORITY' | translate
                    "
                    aria-label="priority-error"
                  />
                }
              </div>
              @if (taskCreateType() !== getTaskCreateType.Automation) {
                <div class="col-6 md:col-3" aria-label="assigned-to-section">
                  <label
                    for="selectedAssigned"
                    class="text-700 text-xs mb-2 block uppercase"
                    aria-label="assigned-to-label"
                  >
                    {{ 'Shared.TASK.TASK-CREATE.ASSIGNED_TO' | translate }}
                  </label>
                  <div class="">
                    <staff-selector
                      [formGroup]="formGroup"
                      [controlName]="SelectedAssigned"
                      [id]="assignedToId"
                      [styleClass]="' border-none surface-50 w-full text-sm'"
                      aria-label="staff-selector"
                    />
                  </div>
                  @if (SelectedAssigned.dirty && SelectedAssigned.invalid) {
                    <app-error-msg
                      [errors]="SelectedAssigned.errors"
                      [fieldLabel]="
                        'Shared.TASK.TASK-CREATE.SELECT_ASSIGNED' | translate
                      "
                      aria-label="assigned-to-error"
                    />
                  }
                </div>
              }
            </div>
            <hr
              class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-0 mb-3"
            />
            <div class="grid md:mb-0 mb-2" aria-label="schedule-section">
              <div
                class="col-12 md:col-9"
                aria-label="schedule-details-section"
              >
                @if (taskCreateType() !== getTaskCreateType.Automation) {
                  <label
                    for="schedule-label"
                    class="font-medium text-xs uppercase text-700 mb-2 block"
                    aria-label="schedule-label"
                  >
                    {{ 'Shared.TASK.TASK-CREATE.SCHEDULE' | translate }}
                  </label>
                }
                <div class="grid" aria-label="schedule-grid">
                  @if (taskCreateType() !== getTaskCreateType.Automation) {
                    <div class="col-6" aria-label="schedule-date-section">
                      <p-datepicker
                        id="calendar-12h"
                        inputId="calendar-12h"
                        formControlName="scheduleDate"
                        [showTime]="true"
                        styleClass="text-sm w-full"
                        inputstyleClass="text-sm m-0 border-400 border-round"
                        [placeholder]="
                          'Shared.TASK.TASK-CREATE.PLACEHOLDER_SELECT_DATE'
                            | translate
                        "
                        [minDate]="minimumDate"
                        [hourFormat]="'12'"
                        aria-label="schedule-date-picker"
                      />
                      @if (ScheduleDate.dirty && ScheduleDate.invalid) {
                        <app-error-msg
                          [errors]="ScheduleDate.errors"
                          [fieldLabel]="
                            'Shared.TASK.TASK-CREATE.SCHEDULE_DATE' | translate
                          "
                          aria-label="schedule-date-error"
                        />
                      }
                    </div>
                  }
                  <div
                    class="col-6 relative"
                    aria-label="schedule-time-section"
                  >
                    <p-datepicker
                      inputId="calendar-timeonly"
                      styleClass="w-full"
                      inputstyleClass="text-sm m-0 border-400 border-round"
                      formControlName="scheduleTime"
                      [hourFormat]="'12'"
                      [placeholder]="
                        'Shared.TASK.TASK-CREATE.PLACEHOLDER_SELECT_TIME'
                          | translate
                      "
                      [timeOnly]="true"
                      aria-label="schedule-time-picker"
                    />

                    @if (ScheduleTime.dirty && ScheduleTime.invalid) {
                      <app-error-msg
                        [errors]="ScheduleTime.errors"
                        [fieldLabel]="
                          'Shared.TASK.TASK-CREATE.SCHEDULE_TIME' | translate
                        "
                        aria-label="schedule-time-error"
                      />
                    }
                  </div>
                </div>
              </div>
              @if (taskCreateType() === getTaskCreateType.Single) {
                <div class="col-12 -mt-2" aria-label="repeat-section">
                  <label
                    for="repeat-label"
                    class="font-medium text-xs text-700 mb-2 uppercase block"
                    aria-label="repeat-label"
                  >
                    {{ 'Shared.TASK.TASK-CREATE.REPEAT' | translate }}
                  </label>
                  <!-- Input Field -->
                  @if (!isRruleSet) {
                    <div
                      class="p-input-icon-right inline-block w-full md:w-auto text-sm mr-3"
                      (click)="showRRule = true"
                      aria-label="repeat-select"
                      data-testid="repeat-select"
                    >
                      <div
                        class="p-inputtext p-component p-element bg-blue-50 md:w-15rem cursor-pointer"
                      >
                        Select...
                      </div>
                    </div>
                  }
                  @if (isRruleSet) {
                    <div
                      class="p-input-icon-right w-full text-sm cursor-pointer"
                      aria-label="repeat-selected"
                    >
                      <i
                        class="fa fa-times text-xl text-600"
                        (click)="clearRRuleData()"
                        aria-label="clear-repeat"
                        data-testid="clear-repeat"
                      ></i>
                      <div
                        class="p-inputtext p-component p-element w-full"
                        (click)="showRRule = true"
                        aria-label="repeat-value"
                        data-testid="repeat-value"
                      >
                        {{ RRuleData.RRuleText }}
                      </div>
                    </div>
                  }
                  <!-- Input Field -->
                </div>
              }
            </div>
            <label
              for="title"
              class="font-medium text-xs text-700 my-2 block"
              aria-label="title-label"
            >
              {{ 'Shared.TASK.TASK-CREATE.TITLE' | translate }}
            </label>
            <input
              type="text"
              pInputText
              class="w-full text-sm"
              formControlName="title"
              placeholder="{{
                'Shared.TASK.TASK-CREATE.PLACEHOLDER_TITLE' | translate
              }}"
              aria-label="title-input"
            />
            @if (Title.touched && Title.invalid) {
              <app-error-msg
                [errors]="Title.errors"
                [fieldLabel]="
                  'Shared.TASK.TASK-CREATE.SELECT_TITLE' | translate
                "
                aria-label="title-error"
              />
            }
          </div>
          <!-- Content -->
          <!-- Content -->
          <div
            class="surface-50 px-4 py-3 text-sm border-bottom-1 border-400"
            aria-label="comments-section"
          >
            <textarea
              pInputTextarea
              class="w-full text-sm h-6rem"
              formControlName="comment"
              placeholder="{{
                'Shared.TASK.TASK-CREATE.PLACEHOLDER_COMMENTS' | translate
              }}..."
              aria-label="comments-input"
            ></textarea>
            @if (Comment.touched && Comment.invalid) {
              <app-error-msg
                [errors]="Comment.errors"
                [fieldLabel]="
                  'Shared.TASK.TASK-CREATE.SELECT_COMMENT' | translate
                "
                aria-label="comments-error"
              />
            }
          </div>
          <!-- Content -->
        </div>
      </div>

      <!-- Modal Footer -->
      <div
        class="p-3 sticky bottom-0 left-0 w-100 surface-0 z-1 border-top-1 border-300 flex align-items-center justify-content-between"
        aria-label="modal-footer"
      >
        <p-button
          label="{{ 'Shared.TASK.TASK-CREATE.CANCEL' | translate }}"
          styleClass="p-button-link text-sm"
          (click)="closeCreateTaskPopup()"
          aria-label="task-create-cancel-button"
        />
        @if (
          taskCreateType() !== getTaskCreateType.Campaign &&
          taskCreateType() !== getTaskCreateType.Automation
        ) {
          <div>
            <button
              type="submit"
              class="text-sm"
              pButton
              pRipple
              label="{{ 'Shared.TASK.TASK-CREATE.CREATE' | translate }}"
              [disabled]="!formGroup.valid"
              [loading]="btnLoading"
              aria-label="task-create-button"
            ></button>
          </div>
        }
        @if (
          taskCreateType() === getTaskCreateType.Campaign ||
          taskCreateType() === getTaskCreateType.Automation
        ) {
          <div>
            <button
              type="button"
              class="text-sm"
              pButton
              pRipple
              [label]="'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate"
              [disabled]="!formGroup.valid"
              [loading]="btnLoading"
              (click)="SaveData()"
              aria-label="task-submit-button"
            ></button>
          </div>
        }
      </div>
      <!-- Modal Footer -->

      <!-- Child Components -->
      <app-rrule
        [visible]="showRRule"
        [rRuleObj]="RRuleData"
        [showNeverStop]="false"
        (hideRrule)="HideRRule($event)"
        (emitRRule)="FetchRRuleData($event)"
        aria-label="repeat-rule-dialog"
      />
      <!-- Child Components -->

      <!-- Error -->
      @if (showErrorPopup | async; as show_Popup) {
        <app-errors
          [visible]="show_Popup"
          [errorData]="errorMessages"
          (hideErrorPopup)="HideErrorPopup($event)"
          aria-label="error-popup"
        />
      }
      <!-- Error -->
    </form>
  </ng-template>
</p-dialog>

<!-- <create-client-profile-sidebar *ngIf="showCreateProspectPopup$ | async as showPopup" [showProspect]="showPopup" (hideProspect)="hideProspectFormPopup($event)" aria-label="prospect-form-dialog"> </create-client-profile-sidebar> -->
